import { TrackingEventsActionTypes } from './constants';

export const INIT_STATE = {
    loadingTrackingEvents: false,
    error: null,
    trackingEvents: null,
};

type TrackingEventsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    loadingTrackingEvents: Boolean,
    error?: null,
    trackingEvents: any,
};

const TrackingEvents = (state: State = INIT_STATE, action: TrackingEventsAction): any => {
    switch (action.type) {
        case TrackingEventsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TrackingEventsActionTypes.GET_ALL_TRACKING_EVENTS_REQUEST: {
                    return { 
                        ...state, 
                        loadingTrackingEvents: false, 
                        trackingEvents: action.payload.data
                    };
                }
                default:
                    return { ...state, loadingTrackingEvents: false };
            }

        case TrackingEventsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TrackingEventsActionTypes.GET_ALL_TRACKING_EVENTS_REQUEST: {
                    return { ...state, loadingTrackingEvents: false, error: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case TrackingEventsActionTypes.GET_ALL_TRACKING_EVENTS_REQUEST:
            return { ...state, loadingTrackingEvents: true, trackingEvents: null };
        default:
            return { ...state };
    }
};

export default TrackingEvents;
